module.exports = __webpack_public_path__ + "img/cafe_pc_02_v1.4507bbcb.png";